import React, { Fragment, useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { BrowserView, MobileView } from "react-device-detect";
// import pdfPresentacionEn from "../Icons/Redinet_ExecutivePresentation_2026.pdf";
// import pdfPresentacionEs from "../Icons/Redinet_PPT_Ejecutiva-2026.pdf";
// import pdfPresentacionBr from "../Icons/Redinet_Presentação_Executiva2026.pdf";
import button from "../Components/Chatbot/Image/button.webp";
import img_ppt from "../Components/Chatbot/Image/img-ppt.webp";
import img_chat from "../Components/Chatbot/Image/img-chatbot.webp";
import Chatbots from "../Components/Chatbot/Chatbot";
import { ContextDataChat } from "../../src/index";
import axios from "axios";

export const pdfPresentacionEn = "https://cdn.redinet.us/Recursos/PresentacionesEjecutivas/Redinet_ExecutivePresentation.pdf";
export const pdfPresentacionEs = "https://cdn.redinet.us/Recursos/PresentacionesEjecutivas/Redinet_PresentacionEjecutiva.pdf";
export const pdfPresentacionBr = "https://cdn.redinet.us/Recursos/PresentacionesEjecutivas/Redinet_PresentaçãoExecutiva.pdf";

export const downloadPdf = async (urlBlob) => {
  const response = await fetch(urlBlob);
  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = urlBlob.split('/').pop();
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export function ToggleComp(props) {

  const [open, setOpen] = useState(false);
  const [ejecutado, setejecutado] = useState(false);
  const { ObjChat, setObjChat } = useContext(ContextDataChat);
  const handleClick = () => {
    setOpen(!open);
  };
  const [t, i18n] = useTranslation("common");

  function startChatbot() {
    if (ejecutado == false) {
      setOpen(!open);
      setejecutado(true)

    }
  }
  if (ejecutado == false) {
    setTimeout(startChatbot, 10000);
    setejecutado(true);
  }
  const domainName = window.location.hostname;

  return (
    // Reemplazamos Fragment con div para permitir className
    <div className="ToogleSection">
      <BrowserView>
        {open ? <Chatbots /> : null}
        {open ? (
          <button className="close-chat" onClick={handleClick}>
            X
          </button>
        ) : null}
        <div className="boton:option ToggleComp">
          <button className="botonF1">
            <div className="menu-option-f1">
              <div className="bontonf1:hover1">
                <button onClick={handleClick}>
                  <img src={img_chat} className="button-image2" />
                </button>
              </div>
              <div className="bontonf1:hover2">
                <button onClick={(s) => { downloadPdf(domainName.includes('iwsservices.com.br') ? pdfPresentacionBr : (domainName.includes('redinet.us')) || domainName.includes('iwsservices.us') || domainName.includes('iwsservices.ca') ? pdfPresentacionEn : pdfPresentacionEs); s.stopPropagation(); }}>
                  {/* <a href={domainName.includes('iwsservices.com.br') ? pdfPresentacionBr : (domainName.includes('redinet.us')) || domainName.includes('iwsservices.us') || domainName.includes('iwsservices.ca') ? pdfPresentacionEn : pdfPresentacionEs} download> */}
                  <img src={img_ppt} className="button-image3" />
                  {/* </a> */}
                </button>
              </div>
            </div>
          </button>
        </div>
      </BrowserView>

      <MobileView>
        {open ? <Chatbots /> : null}
        {open ? (
          <button className="close-chat" onClick={handleClick}>
            X
          </button>
        ) : null}
        <div className="boton:option">
          <button className="botonF1">
            <img src={button} className="button-image" />
            <div className="menu-option-f1">
              <div className="bontonf1:hover1">
                <button onClick={handleClick}>
                  <img src={img_chat} className="button-image2" />
                </button>
              </div>

              <div className="bontonf1:hover2">
                <button onClick={(s) => { downloadPdf(domainName.includes('iwsservices.com.br') ? pdfPresentacionBr : (domainName.includes('redinet.us')) || domainName.includes('iwsservices.us') || domainName.includes('iwsservices.ca') ? pdfPresentacionEn : pdfPresentacionEs); s.stopPropagation(); }}>
                  {/* <a href={domainName.includes('iwsservices.com.br') ? pdfPresentacionBr : (domainName.includes('redinet.us')) || domainName.includes('iwsservices.us') || domainName.includes('iwsservices.ca') ? pdfPresentacionEn : pdfPresentacionEs} download> */}
                  <img src={img_ppt} className="button-image3" />
                  {/* </a> */}
                </button>
              </div>
            </div>
          </button>
        </div>
      </MobileView>

    </div>

  );

}



export default ToggleComp;